import {
  Box,
  Button,
  IconButton,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { useMediaQuery } from "@braintrust/braintrust-ui-components";
import { CloseIcon } from "@braintrust/braintrust-ui-components/Icons";
import { ModalInstance } from "@js/components/modal";

import { useOnboardingPopup } from "./hook";

import styles from "./style.module.scss";

type OnboardingPopupProps = {
  onClose: () => void;
};

export const OnboardingPopup = ({ onClose }: OnboardingPopupProps) => {
  const { handleEmployerAccountClick, handlePersonalAccountClick } =
    useOnboardingPopup();

  return (
    <>
      <Header onClose={onClose} />
      <Content />
      <Footer
        onEmployerAccountClick={handleEmployerAccountClick}
        onPersonalAccountClick={handlePersonalAccountClick}
      />
    </>
  );
};

const Header = ({ onClose }: Pick<OnboardingPopupProps, "onClose">) => (
  <div className={styles.header}>
    <IconButton
      variant="tertiary"
      size="small"
      aria-label="Close onboarding confirmation popup"
      onClick={onClose}
      className={styles.closeButton}
    >
      <CloseIcon />
    </IconButton>
  </div>
);

const Content = () => (
  <Box sx={{ mt: 3, mb: 6.5 }}>
    <Typography
      variant="title"
      size="medium"
      fontWeight={400}
      component="p"
      sx={{ mb: 1 }}
    >
      Ready to hire? Our team will create an Employer account for you.
    </Typography>
    <Typography variant="paragraph" component="p" sx={{ mb: 2 }}>
      <Typography variant="label" component="span">
        To hire talent or try Braintrust AIR, you’ll need an Employer account
        using your work email address.{" "}
      </Typography>
      Please book a meeting with our team on the next page and we’ll get you
      started!
    </Typography>
    <Typography variant="paragraph" component="p">
      To access the rest of Braintrust, including searching for jobs, earning
      BTRST, getting help from the community, and more, continue creating an
      account with your personal email.
    </Typography>
  </Box>
);

const Footer = ({
  onEmployerAccountClick,
  onPersonalAccountClick,
}: {
  onEmployerAccountClick: () => void;
  onPersonalAccountClick: () => void;
}) => {
  const isMobile = useMediaQuery("sm");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: 1,
        justifyContent: "flex-end",
      }}
    >
      <Button
        variant="secondary"
        shape="squared"
        onClick={onPersonalAccountClick}
      >
        Continue with a Talent account
      </Button>
      <Button
        variant="primary"
        shape="squared"
        onClick={onEmployerAccountClick}
      >
        Get an Employer account
      </Button>
    </Box>
  );
};

export const openOnboardingConfirmationPopup = () => {
  ModalInstance.open({
    children: <OnboardingPopup onClose={ModalInstance.close} />,
    className: styles.modalWrapper,
    keepOnBackdropClick: true,
    closeButton: false,
    padding: false,
  });
};
